/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphBarHorizontalStackedIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Graph Bar Horizontal Stacked',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="34" rx=".5" ry=".5" width="2" x="2" y="2" />
    <path
      d="M6 20h6v6H6zM6 4h14v6H6zM6 28h4v6H6zM6 12h10v6H6zM25 12h-7v6h7a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1ZM33 4H22v6h11a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1ZM17 20h-3v6h3a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1ZM15 28h-3v6h3a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Z"
    />
  </svg>`;
};
